/**
 * @flow
 * @relayHash c8591b42c323ed490afdea18a6ccef41
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ContractTemplateState = "A_1" | "A_2" | "A_3" | "%future added value";
export type MarkContractTemplateActiveInput = {|
  id: string,
  clientMutationId?: ?string,
|};
export type MarkContractTemplateActiveMutationVariables = {|
  input: MarkContractTemplateActiveInput
|};
export type MarkContractTemplateActiveMutationResponse = {|
  +markContractTemplateActive: ?{|
    +contractTemplate: ?{|
      +id: string,
      +state: ContractTemplateState,
      +activationDate: ?any,
    |}
  |}
|};
export type MarkContractTemplateActiveMutation = {|
  variables: MarkContractTemplateActiveMutationVariables,
  response: MarkContractTemplateActiveMutationResponse,
|};
*/


/*
mutation MarkContractTemplateActiveMutation(
  $input: MarkContractTemplateActiveInput!
) {
  markContractTemplateActive(input: $input) {
    contractTemplate {
      id
      state
      activationDate
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "MarkContractTemplateActiveInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "markContractTemplateActive",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MarkContractTemplateActivePayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "contractTemplate",
        "storageKey": null,
        "args": null,
        "concreteType": "ContractTemplateNode",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "state",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "activationDate",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "MarkContractTemplateActiveMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "MarkContractTemplateActiveMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "MarkContractTemplateActiveMutation",
    "id": null,
    "text": "mutation MarkContractTemplateActiveMutation(\n  $input: MarkContractTemplateActiveInput!\n) {\n  markContractTemplateActive(input: $input) {\n    contractTemplate {\n      id\n      state\n      activationDate\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a1550aa6ecc2fe9a6c5fc8d66209eb87';
module.exports = node;
